export const GET_IMAGEGALLARY_REQUEST = 'GET_IMAGEGALLARY_REQUEST'
export const GET_IMAGEGALLARY_SUCCESS = 'GET_IMAGEGALLARY_SUCCESS'
export const GET_IMAGEGALLARY_FAIL = 'GET_IMAGEGALLARY_FAIL'